// ToolbarEnhanced.jsx
import React from "react";
import "./ToolbarEnhanced.css";

export default function ToolbarEnhanced({
  selectedProject,
  projectName,
  onNameChange,
}) {
  const hasProject = !! selectedProject;

  return (
    <div>
      <div className="toolbar justify-content">

      {/* TOP ROW: New + Open */}
      
        {/* <button className="btn-primary-toolbar" onClick={onNewProject}>
          ➕ New Project
        </button>

        <button className="btn-secondary-toolbar" onClick={onOpenProject}>
          📁 Open Project
        </button> */}

              {/* PROJECT NAME INPUT WHEN PROJECT IS LOADED */}
      {hasProject && (
        <div className="toolbar-projectname">
          <span>Project Name:</span>
          <input
            type="text"
            value={projectName}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="Project Name"
          />
        </div>
      )}
     </div>

      {/* MESSAGE WHEN NO PROJECT */}
      {!hasProject && (
        <div className="toolbar-center-label">
          <h3>Open or Create a New 📁 Project</h3>
        </div>
      )}


    </div>    
  );
}